import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.AUTHENTICATION.SET_CLIENT_TRANSFER_TOKEN,
  payload,
})
